import { LoadingDotsIndicator } from '@deliveryhero/pd-cookbook/components/LoadingDotsIndicator';

export const LoadingAnimation = () => {
  return (
    <div
      data-testid="loading-dots"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
        color: '#E21B70'
      }}
    >
      <LoadingDotsIndicator />
    </div>
  );
};
